import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-component summary-content" }
const _hoisted_2 = { class: "p-grid p-jc-between" }
const _hoisted_3 = { class: "p-d-inline-flex p-ai-center" }
const _hoisted_4 = { class: "p-col-4" }
const _hoisted_5 = { class: "p-col-8" }
const _hoisted_6 = { class: "p-d-inline-flex p-ai-center" }
const _hoisted_7 = { class: "p-col-4" }
const _hoisted_8 = { class: "p-col-8" }
const _hoisted_9 = { class: "p-col-4" }
const _hoisted_10 = { class: "p-col-8" }
const _hoisted_11 = { class: "p-col-4" }
const _hoisted_12 = { class: "p-col-8" }
const _hoisted_13 = { class: "p-col-4" }
const _hoisted_14 = { class: "p-d-inline-flex p-ai-center" }
const _hoisted_15 = { class: "p-col-4" }
const _hoisted_16 = { class: "p-col-8" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "p-grid" }
const _hoisted_23 = { class: "p-col-6 p-text-left p-mt-2" }
const _hoisted_24 = { class: "p-col-6 p-text-right p-mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.tenantExists)
          ? (_openBlock(), _createBlock(_component_Message, {
              key: 0,
              severity: "warn",
              closable: false
            }, {
              default: _withCtx(() => [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t('System-Administration.General.Warning')), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('System-Administration.Tenants.TenantWarningMessage')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_Divider, { align: "left" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _cache[0] || (_cache[0] = _createElementVNode("i", { class: "mdi mdi-badge-account-horizontal-outline p-mr-2" }, null, -1)),
              _createElementVNode("b", null, _toDisplayString(_ctx.$t('System-Administration.Tenants.Tenant')), 1)
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('System-Administration.Tenants.Tenant')) + ": ", 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.tenant), 1),
        _createVNode(_component_Divider, { align: "left" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _cache[1] || (_cache[1] = _createElementVNode("i", { class: "mdi mdi-account-outline p-mr-2" }, null, -1)),
              _createElementVNode("b", null, _toDisplayString(_ctx.$t('System-Administration.General.AdminUser')), 1)
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('System-Administration.Login.Firstname')) + ": ", 1),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.adminUser.firstname), 1),
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('System-Administration.Login.Lastname')) + ": ", 1),
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.adminUser.lastname), 1),
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('System-Administration.Login.Email')) + ": ", 1),
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.adminUser.email), 1),
        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('System-Administration.Login.Password')) + ": ", 1),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "p-col-8" }, " ****** ", -1)),
        _createVNode(_component_Divider, { align: "left" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _cache[2] || (_cache[2] = _createElementVNode("i", { class: "mdi mdi-application p-mr-2" }, null, -1)),
              _createElementVNode("b", null, _toDisplayString(_ctx.$t('System-Administration.Templates.Templates')), 1)
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('System-Administration.Templates.Templates')) + ": ", 1),
        _createElementVNode("div", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allTemplates, (template) => {
            return (_openBlock(), _createElementBlock("ul", {
              key: template.key
            }, [
              (template.checked)
                ? (_openBlock(), _createElementBlock("li", _hoisted_17, _toDisplayString(template.label), 1))
                : _createCommentVNode("", true),
              (template.checked)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(template.children, (child) => {
                      return (_openBlock(), _createElementBlock("ul", {
                        key: child.key
                      }, [
                        (child.checked)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_19, _toDisplayString(child.label), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (!template.checked)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(template.children, (child) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: child.key
                      }, [
                        (child.checked)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_21, _toDisplayString(child.label), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_Button, {
          icon: "mdi mdi-arrow-left",
          class: "p-button-rounded p-button-outlined",
          onClick: _ctx.goToPreviousStep
        }, null, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_Button, {
          icon: "mdi mdi-arrow-right",
          class: "p-button-rounded p-button-outlined",
          onClick: _ctx.goToNextStep
        }, null, 8, ["onClick"])
      ])
    ])
  ], 64))
}